<div [ngClass]="getContainerClasses()">
  <p-progressSpinner [style]="getSpinnerStyle()" [strokeWidth]="strokeWidth" animationDuration="1s" />
  @if (message()) {
    <p [ngClass]="getMessageClasses()">
      {{ message() }}
    </p>
  }
</div>
